module.exports = __webpack_public_path__ + "static/reviewImage-c17f4c52cd2a7f739d78c56cbc10d66b.png";